import React from "react";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonGrid,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonNote,
  IonRow,
  IonSkeletonText,
} from "@ionic/react";
import { useSelector } from "react-redux";
import { selectViewMode } from "../../../store/documentsSignerList/selectors/selectViewMode";

export const DocumentSectionListLoading: React.FC = () => {
  const viewMode = useSelector(selectViewMode);

  return (
    <section>
      {viewMode === "grid" ? (
        <IonGrid>
          <IonRow>
            {[...Array(9)].map((document, index: number) => (
              <IonCol size="12" sizeMd="6" sizeLg="4" key={index}>
                <IonCard style={{ height: "285px" }}>
                  <IonCardHeader
                    style={{
                      padding: 0,
                      display: "flex",
                      justifyContent: "center",
                      background: "#cccccc",
                    }}
                  >
                    <img
                      src={
                        "https://programacion.net/files/article/20161110041116_image-not-found.png"
                      }
                      alt="Imagen documento"
                      style={{
                        height: "168px",
                        objectFit: "cover",
                        background: "white",
                      }}
                    />
                  </IonCardHeader>
                  <IonCardContent>
                    <h1 style={{ height: "60px" }}>
                      <IonSkeletonText animated style={{ width: "80%", height: 25 }} />
                    </h1>
                    <IonSkeletonText animated style={{ width: "80%", height: 17 }} />
                    <IonSkeletonText animated style={{ width: "80%", height: 17 }} />
                  </IonCardContent>
                </IonCard>
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      ) : (
        <IonList>
          <IonListHeader>
            <IonLabel>
              <IonSkeletonText animated style={{ width: "20%" }} />
            </IonLabel>
          </IonListHeader>
          {[...Array(9)].map((item, index) => (
            <IonItem key={index} lines="none">
              <IonLabel>
                <h3>
                  <IonSkeletonText animated style={{ width: "50%" }} />
                </h3>
                <p>
                  <IonSkeletonText animated style={{ width: "70%" }} />
                </p>
              </IonLabel>
              <IonNote slot="end">
                <IonSkeletonText animated style={{ width: "20%" }} />
              </IonNote>
            </IonItem>
          ))}
        </IonList>
      )}
    </section>
  );
};
